<template>
    <el-dialog :visible="visible" width="" :before-close="onClose" :close-on-click-modal="false" class="ah-detail-dialog invoice-serial-number-edit-dialog" id="" @open="onOpen">
        <template slot="title">新增發票字軌</template>
        <div class="detail-row" style="padding-top: 30px">
            <div class="detail-block">
                <el-form ref="form" :rules="rules" :model="form" v-loading="isLoading" label-width="120px">
                    <div style="margin: 0 auto 20px auto">
                        <el-form-item prop="prefixType" label="開立類型">
                            <el-radio-group v-model="form.prefixType">
                                <el-radio :label="1">
                                    <div class="prefix-type-radio">
                                        <div class="prefix-type-name">手開發票</div>
                                        <div class="prefix-type-note">(財政部、其他加值中心)</div>
                                    </div>
                                </el-radio>
                                <el-radio :label="2">
                                    <div class="prefix-type-radio">
                                        <div class="prefix-type-name">電子發票串接</div>
                                        <div class="prefix-type-note">(EzPay、紅陽電子發票)</div>
                                    </div>
                                </el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="yer" label="年份">
                            <el-select v-model="form.yer" :disabled="form.sno != null" placeholder="年份">
                                <el-option v-for="item in yearList" :label="`${item - 1911} 年`" :value="item" :key="`year_option_${item}`"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="moN_TYP" label="期別">
                            <el-select v-model="form.moN_TYP" :disabled="form.sno != null" placeholder="期別">
                                <el-option v-for="p in phaseOptions" :label="p.label" :value="p.sno" :key="p.sno"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="startPrefix" label="字軌號碼(起)">
                            <ahElInputInvoice v-model="form.startPrefix" />
                        </el-form-item>
                        <el-form-item prop="endPrefix" label="字軌號碼(訖)">
                            <ahElInputInvoice v-model="form.endPrefix" />
                        </el-form-item>
                    </div>
                </el-form>
            </div>
        </div>
        <div class="detail-row footer" style="text-align: center">
            <el-button ref="actionBtn" type="primary" class="primary-action" :loading="isLoading" @click="onSubmit">
                {{ form.sno == null ? "新增" : "儲存" }}
            </el-button>
            <el-button type="" v-if="form.sno != null" @click="onDelete"> 刪除 </el-button>
        </div>
    </el-dialog>
</template>

<script>
import ahElInputInvoice from '@/components/ui/ahElInputInvoice.vue';

export default {
    components: { ahElInputInvoice },
    props: {
        visible: Boolean,
        mode: String,
        target: Object,
        queryYER: [Number, String],
    },
    data() {
        const invoiceValidate = (rule, value, callback) => {
            if (!value) callback(new Error('請輸入字軌'));
            else if (value.length < 10) callback(new Error('請輸入完整發票字軌'));
            callback();
        };
        return {
            invoiceSerialInputKey: +new Date(),
            yearList: [],
            phaseOptions: [
                {
                    sno: 1,
                    label: '1 ~ 2月',
                },
                {
                    sno: 2,
                    label: '3 ~ 4月',
                },
                {
                    sno: 3,
                    label: '5 ~ 6月',
                },
                {
                    sno: 4,
                    label: '7 ~ 8月',
                },
                {
                    sno: 5,
                    label: '9 ~ 10月',
                },
                {
                    sno: 6,
                    label: '11 ~ 12月',
                },
            ],
            form: {
                sno: null,
                prefixType: 1,
                yer: new Date().getFullYear(),
                moN_TYP: null,
                startPrefix: null,
                endPrefix: null,
            },
            rules: {
                moN_TYP: [
                    {
                        required: true,
                        message: '請選擇期別',
                        trigger: 'change',
                    },
                ],
                startPrefix: [
                    {
                        required: true,
                        validator: invoiceValidate,
                        trigger: 'blur',
                    },
                ],
                endPrefix: [
                    {
                        required: true,
                        validator: invoiceValidate,
                        trigger: 'blur',
                    },
                ],
            },
            isLoading: false,
        };
    },
    methods: {
        onOpen() {
            this.invoiceSerialInputKey = +new Date();

            if (this.mode === 'CREATE') {
                const thisYear = new Date().getFullYear();
                for (let i = thisYear - 2; i <= thisYear + 1; i += 1) {
                    this.yearList.push(i);
                }
                this.yearList.reverse();

                // 檢查是否包含可編輯年份
                if (this.yearList.includes(this.queryYER)) {
                    this.form.yer = this.queryYER;
                } else this.form.yer = thisYear;
            } else this.fetchEditTarget(this.target);
        },
        onClose() {
            this.resetForm();
            this.$emit('close');
        },

        onSubmit() {
            this.$refs.form.validate(async (valid) => {
                if (valid) {
                    this.isLoading = true;
                    try {
                        await this.$api({
                            url: this.form.sno == null ? '/InvoicePrefix/AddSetting' : '/InvoicePrefix/UpdateSetting',
                            data: this.form,
                            method: 'POST',
                        });

                        this.$emit('close');
                        this.$emit('afterSubmit', this.form.yer);
                        this.resetForm();
                    } catch (e) {
                        console.log(e);
                    } finally {
                        this.isLoading = false;
                    }
                }
            });
        },

        async onDelete() {
            try {
                await this.$confirm('確定要刪除？', {
                    confirmButtonText: '確定',
                    cancelButtonText: '取消',
                });
                this.onDeleteConfirm();
            } catch (e) {
                console.log(e);
            }
        },
        async onDeleteConfirm() {
            this.isLoading = true;

            try {
                await this.$api({
                    url: '/InvoicePrefix/DeleteSetting',
                    data: { sno: this.form.sno },
                    method: 'POST',
                });

                this.$emit('close');
                this.$emit('afterDelete', this.form.yer);
                this.resetForm();
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        async fetchEditTarget({ sno }) {
            try {
                this.isLoading = true;
                const RESP = await this.$api({
                    url: '/InvoicePrefix/GetDetail',
                    params: { sno },
                    method: 'GET',
                });
                this.form.sno = RESP.data.detail.sno;
                this.form.prefixType = RESP.data.detail.prefixType;
                this.yearList.push(RESP.data.detail.yer);
                this.form.yer = RESP.data.detail.yer;
                this.form.moN_TYP = RESP.data.detail.moN_TYP;
                this.form.startPrefix = RESP.data.detail.startPrefix;
                this.form.endPrefix = RESP.data.detail.endPrefix;
            } catch (e) {
                console.log(e);
            } finally {
                this.isLoading = false;
            }
        },

        resetForm() {
            this.form.sno = null;
            this.form.prefixType = 1;
            this.form.yer = this.queryYER;
            this.form.moN_TYP = null;
            this.form.startPrefix = null;
            this.form.endPrefix = null;
            this.yearList = [];

            this.$nextTick(() => {
                this.$refs.form.clearValidate();
            });
        },
    },
};
</script>

<style lang="scss">
.ah-detail-dialog.invoice-serial-number-edit-dialog {
    .el-dialog {
        max-width: 550px;
    }
    .el-radio__label {
        vertical-align: top;
    }
    .prefix-type-radio {
        display: inline-block;
        vertical-align: top;

        .prefix-type-note {
            font-size: 9pt;
            color: #aaa;
            margin-top: 5px;
        }
    }
}
</style>
